import { useMutation } from '@tanstack/react-query'
import { ReactQueryOptions } from 'ComponentLibrary'
import { getValuationApiClient } from 'ClientPortal/src/api/valuationApiClient'
import { useGlobalMutationErrorHandler } from 'ClientPortal/src/api/useGlobalMutationErrorHandler'
import { getSelectedCustomer, useSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'

export function useGetAllOrderDocumentsZipUrl({ onSuccess, onError }: ReactQueryOptions<string>) {
    const handleError = useGlobalMutationErrorHandler(onError)

    const { isPending: isGeneratingDocumentsZipUrl, mutate: generateDocumentsZipUrl } = useMutation({
        mutationFn: (orderId: string) =>
            getValuationApiClient().orders.getDownloadAllOrderDocumentsLinkToZip(orderId, { customerId: getSelectedCustomer()?.uuid }),
        onSuccess,
        onError: handleError,
    })

    return {
        isGeneratingDocumentsZipUrl,
        generateDocumentsZipUrl,
    }
}

export function useGetAllOrderImagesZipUrl({ onSuccess, onError }: ReactQueryOptions<string>) {
    const handleError = useGlobalMutationErrorHandler(onError)

    const { isPending: isGeneratingImagesZipUrl, mutate: generateImagesZipUrl } = useMutation({
        mutationFn: (orderId: string) =>
            getValuationApiClient().orders.getDownloadAllOrderImagesLinkToZip(orderId, { customerId: getSelectedCustomer()?.uuid }),
        onSuccess,
        onError: handleError,
    })

    return {
        isGeneratingImagesZipUrl,
        generateImagesZipUrl,
    }
}

export function useAllReportsZipUrl({ assetId, onSuccess, onError }: { assetId: string } & ReactQueryOptions<string>) {
    const handleError = useGlobalMutationErrorHandler(onError)

    const {
        isPending: isGeneratingAllReportsZipUrl,
        mutate: generateAllReportsZipUrl,
        data,
        isError: isErrorGeneratingAllReportsZipUrl,
    } = useMutation({
        mutationFn: () => getValuationApiClient().assets.getAllReportsLinkToZip({ assetId, customerId: getSelectedCustomer()?.uuid }),
        onSuccess,
        onError: handleError,
    })

    return {
        allReportsZipUrl: data,
        generateAllReportsZipUrl,
        isGeneratingAllReportsZipUrl,
        isErrorGeneratingAllReportsZipUrl,
    }
}

export function useValXmlBulkExportUrl({ onSuccess, onError }: ReactQueryOptions<string>) {
    const { selectedCustomer } = useSelectedCustomer()
    const handleError = useGlobalMutationErrorHandler(onError)

    const { isPending: isGeneratingValXmlBulkExportUrl, mutate: generateValXmlBulkExportUrl } = useMutation({
        mutationFn: () => getValuationApiClient().portfolios.getValXmlBulkExportLink({ customerUuid: selectedCustomer?.uuid }),
        onSuccess,
        onError: handleError,
    })

    return {
        isGeneratingValXmlBulkExportUrl,
        generateValXmlBulkExportUrl,
    }
}
